import { Box, Divider } from "@mui/material";
import { useState } from "react";
import Flex from "../../../../../../../components/Flex";
import OutlineCard from "../../../../../../../components/OutlineCard";
import { ScrollArea } from "../../../../../../../components/ScrollBar";
// import Text from "../../../../../../../components/Text";
import { GetPatientSocialHistorySocialHistoryTypeEnum } from "../../../../../../../services";
import { SOCIAL_HISTORY_QUESTION_ENUM_LIST } from "./history-constant";
import SelectedQuestionLayout from "./social-history/SelectedQuestionLayout";
import SocialHistoryCard from "./social-history/SocialHistoryCard";
import { useGetAllPatientSocialHistoryStatus } from "../../../../../../../queries/history/social-history/use-get-all-patient-social-history-status";
import { getXtenantId } from "../../../../../../../utils/utils";
import { useParams } from "react-router-dom";

type SelectedCard = {
  cardId: GetPatientSocialHistorySocialHistoryTypeEnum;
  cardIndex: number;
};

const SocialHistoryNew = () => {
  const [selectedCard, setSelectedCard] = useState<SelectedCard>({
    cardId: "HOME_AND_ENVIRONMENT",
    cardIndex: 0,
  });

  const { patientId } = useParams() as { patientId: any };

  const { data: allPatientSocialHistoryStatus } =
    useGetAllPatientSocialHistoryStatus({
      patientUuid: patientId,
      xTENANTID: getXtenantId() ?? "",
    });

  const skipHandler = (currentIdx: number) => {
    const curId = SOCIAL_HISTORY_QUESTION_ENUM_LIST[currentIdx + 1];
    setSelectedCard({
      cardId: curId as any,
      cardIndex: currentIdx + 1,
    });
  };

  return (
    <Flex gap={0} width={"100%"} height={"100%"}>
      <Flex flexShrink={1}>
        <OutlineCard
          sx={{
            width: "100%",
            borderRadius: 0,
            backgroundColor: "#F5F5F5",
            height: "100%",
          }}
        >
          {/* not in Figma */}
          {/* <Flex
            justifyContent={"space-between"}
            height={"40px"}
            alignItems={"start"}
            >
            <Text>Social History Types</Text>
          </Flex> */}
          <ScrollArea height={"100%"}>
            <Box>
              <SocialHistoryCard
                questions={allPatientSocialHistoryStatus?.data ?? {}}
                setSelectedCard={setSelectedCard}
                selectedCard={selectedCard}
              />
            </Box>
          </ScrollArea>
        </OutlineCard>
      </Flex>
      <Flex flexBasis={300} flexShrink={1} flexGrow={1}>
        <OutlineCard
          sx={{
            height: "100%",
            width: "100%",
            borderRadius: 0,
            padding: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Divider sx={{ borderStyle: "dashed" }} />

          <Box sx={{ flex: 1, minHeight: 0 }}>
            <SelectedQuestionLayout
              skipFunction={skipHandler}
              currentIndex={selectedCard?.cardIndex}
              selectedCard={selectedCard?.cardId}
            />
          </Box>
        </OutlineCard>
      </Flex>
    </Flex>
  );
};

export default SocialHistoryNew;
